import { X, RotateCcw, Sparkles } from "lucide-react";

export default function AssistantHeader({ onNewChat, onToggle }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b-2 border-[var(--c-border)] bg-[#1E3A8A] px-4 py-3 text-white">
      <div className="flex items-center gap-2">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg border-2 border-white/30 bg-white/10">
          <Sparkles className="h-4 w-4" />
        </div>
        <div>
          <p className="font-heading text-sm font-black leading-tight">LLC Guide Assistant</p>
          <p className="text-[11px] text-blue-200">Answers from your Texas LLC Guide</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button data-testid="assistant-new-chat" onClick={onNewChat} title="New chat" className="rounded-md p-1.5 text-blue-100 transition-colors hover:bg-white/15 hover:text-white">
          <RotateCcw className="h-4 w-4" />
        </button>
        <button data-testid="assistant-close" onClick={onToggle} aria-label="Close assistant" className="rounded-md p-1.5 text-blue-100 transition-colors hover:bg-white/15 hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
